import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { reasons, trustStats } from "@/mocks/site";

export default function WhySection() {
  return (
    <section id="neden" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionHeading
                align="left"
                eyebrow="Neden d.mar?"
                title="İstanbul'da diş hekimlerinin tercih ettiği merkez"
                description="Modern dijital cihaz altyapısı, aynı gün rapor teslimi ve diş hekimleriyle doğrudan dijital iletişim — Osmanbey'in merkezinde."
              />
            </Reveal>

            <Reveal delay={100}>
              <div className="relative mt-9 overflow-hidden rounded-xl border border-background-200">
                <span
                  className="pointer-events-none absolute inset-x-0 top-0 z-10 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                  aria-hidden="true"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimal%20dental%20imaging%20room%20with%20a%20sleek%20white%203D%20CBCT%20cone%20beam%20scanner%20machine%2C%20warm%20ivory%20walls%2C%20soft%20natural%20daylight%2C%20clean%20professional%20medical%20interior%20with%20green%20plants%2C%20editorial%20photography%2C%20calm%20tones%2C%20no%20people&width=1200&height=900&seq=dmar-cbct-room&orientation=landscape"
                  alt="d.mar Dental Görüntüleme Merkezi 3D dental tomografi (CBCT) cihazı"
                  title="3D dental tomografi (CBCT) cihazı — d.mar Dental Görüntüleme Merkezi"
                  className="h-64 w-full object-cover object-top md:h-72"
                />
              </div>
            </Reveal>

            <Reveal delay={160}>
              <dl className="mt-7 grid grid-cols-2 gap-5">
                {trustStats.slice(0, 2).map((stat) => (
                  <div key={stat.label} className="relative overflow-hidden rounded-xl border border-background-200 bg-background-50 px-5 py-4">
                    <span
                      className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                      aria-hidden="true"
                    />
                    <dt className="font-heading text-2xl font-medium text-primary-700">{stat.value}</dt>
                    <dd className="mt-1 text-xs font-medium uppercase tracking-wide text-foreground-600">
                      {stat.label}
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              {reasons.map((reason, index) => {
                const isAccent = index % 2 === 1;
                return (
                  <Reveal key={reason.title} delay={index * 70}>
                    <article className="relative flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300">
                      <span
                        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
                        aria-hidden="true"
                      />
                      <span
                        className={`flex h-11 w-11 items-center justify-center rounded-lg ring-1 ring-inset ${
                          isAccent
                            ? "bg-accent-100 text-accent-700 ring-accent-300/60"
                            : "bg-primary-100 text-primary-700 ring-primary-300/60"
                        }`}
                      >
                        <i className={`${reason.icon} text-xl`} aria-hidden="true" />
                      </span>
                      <h3 className="mt-4 font-heading text-base font-medium tracking-tight text-foreground-950">
                        {reason.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{reason.text}</p>
                    </article>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}